const PageCityConfig = () => import('@/modules/city/PageCityConfig.vue')

export default [
  {
    path: '/cityConfig',
    name: 'PageCityConfig',
    component: PageCityConfig,
    meta: {
      title: '配置区域信息',
      needLogin: true,
    },
  },

]
